import React from 'react';
import FeatherIcon from 'feather-icons-react';

const ShareButton = ({ type, link }) => {
  return (
    <a
      href={link}
      type="button"
      target="_blank"
      rel="noopener noreferrer"
      className="mr-4 flex items-center rounded-full border-2 border-shop-dark-green hover:bg-shop-dark-green hover:text-white px-4 py-1 text-sm leading-5 text-shop-dark-green transition duration-300 ease-in-out"
    >
      <FeatherIcon
        icon={type.toLowerCase()}
        style={{ width: 20, height: 20 }}
        className="mr-2"
      />
      {type}
    </a>
  );
};

export default ShareButton;
